import { insertEmptyElement, ELEMENT_DEFAULT, select } from '@udecode/plate';
import { Path } from 'slate';

export const insertEmptyElementAfter = (editor, options) => {
  const {
    mode,
    moveSelectionToEmptyElement = false,
  } = options;
  // Insert empty element after image.
  const at = getNextPath(editor, mode);
  insertEmptyElement(
    editor,
    ELEMENT_DEFAULT,
    { at },
  );
  if (moveSelectionToEmptyElement) select(editor, at);
};

// Get next path from current editor selection.
export const getNextPath = (editor, mode) => {
  const { anchor } = editor.selection;
  const { path } = anchor;
  let _path;

  if (path.length === 0) return [];

  switch (mode) {
    case 'highest':
      _path = path.slice(0, 1);
      break;
    default:
      _path = path;
  }
  return Path.next(_path);
};